// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconArrowRightLoop = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M56.8276 24.6366C56.0281 23.7785 43.1239 9.63377 42.2615 8.70824C41.3992 7.7827 40.2786 7.7628 39.384 8.65733C38.4896 9.55174 37.5519 10.4895 36.6574 11.384C35.7629 12.2785 35.7827 13.3992 36.7083 14.2615C37.2375 14.7546 42.1215 19.2152 46.2075 22.9453C41.0488 22.5181 32.9507 22 24 22C14.1274 22 8 28.1274 8 38C8 47.8725 14.1274 54 24 54H32C33.2341 54 34 53.2341 34 52V47.8384C34 46.802 33.2791 46.1838 32.2575 46.3589C30.5839 46.6457 27.7564 47 24 47C18.4467 47 15 43.5533 15 38C15 32.4466 18.4467 29 24 29C32.5161 29 40.6409 29.1709 45.9247 29.3128C41.8995 32.9875 37.2253 37.2567 36.7083 37.7385C35.7827 38.6008 35.7629 39.7214 36.6574 40.616C37.5519 41.5105 38.4895 42.4481 39.384 43.3426C40.2786 44.2372 41.3992 44.2173 42.2615 43.2917C43.1239 42.3662 56.0281 28.2214 56.8276 27.3633C57.6271 26.5052 57.6271 25.4947 56.8276 24.6366Z" />
    </svg>
  );
};
